import React, {useEffect, useState} from 'react';
import {Button, Select, Table} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

const TableProduct = ({user, owner, products, setLots}) => {

  // Données d'exemple pour le tableau (état dynamique)
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    // Vérifier que products et owner existent avant de filtrer
    if (products && owner && owner.proprietaire_id) {
      const data = products.filter(lot => lot.lot_proprietaire.proprietaire_id === owner.proprietaire_id);
      setTableData(data);
    }

    if (user) {
      const data = products.filter(lot => user.lots.includes(lot.lot_id));
      setTableData(data);
    }
  }, [products, owner, user]);

  // Effect pour mettre à jour setLots chaque fois que tableData change
  useEffect(() => {
    const lotIds = tableData.map(lot => lot.lot_id);
    setLots(lotIds);
  }, [tableData, setLots]);

  const columns = [
    {
      title: 'Lot',
      dataIndex: 'lot_reference',
    },
    {
      title: 'Adresse',
      key: 'fullInfo',
      render: (_, record) => (
        <span>{`${record.lot_adresse.adresse_numero} ${record.lot_adresse.adresse_voie} ${record.lot_adresse.adresse_code_postal} ${record.lot_adresse.adresse_ville} ${record.lot_adresse.adresse_pays}`}</span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '10%',
      align: 'center',
      render: (_, record) => (
        <Button
          type="text"
          danger
          size="small"
          icon={<DeleteOutlined size={16} />}
          onClick={() => handleDeleteLot(record.lot_id)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            boxShadow: 'none'
          }}
          title="Supprimer ce lot"
        />
      ),
    },
  ];

  // Fonction pour formater l'affichage des lots dans le sélecteur
  const formatLotLabel = (lot) => {
    const { lot_reference, lot_adresse } = lot;
    return `${lot_reference} - ${lot_adresse.adresse_numero} ${lot_adresse.adresse_voie}, ${lot_adresse.adresse_code_postal} ${lot_adresse.adresse_ville}, ${lot_adresse.adresse_pays}`;
  };

  const handleLotSelect = (value) => {
    const selectedLot = products.find(lot => lot.lot_id === value);
    if (selectedLot) {
      // Vérifier si le lot n'existe pas déjà dans tableData
      const lotExists = tableData.find(item => item.lot_id === value);

      if (!lotExists) {
        setTableData(prev => [...prev, selectedLot]);
      }
    }
  };

  const handleDeleteLot = (id) => {
    setTableData(prev => prev.filter(lot => lot.lot_id !== id));
  };
  return (
    <>
      <h3>Lots de l'utilisateur</h3>
      <Select
        size='large'
        showSearch
        placeholder="Rechercher et sélectionner un lot"
        style={{ width: '100%' }}
        value={null}
        onSelect={handleLotSelect}
        options={products?.map(lot => ({
          value: lot.lot_id,
          label: formatLotLabel(lot)
        }))}
        filterOption={(input, option) =>
          (option.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        allowClear
      />
      <Table
        pagination={false}
        showHeader={false}
        size="middle"
        scroll={{ x: true }}
        columns={columns}
        dataSource={tableData}
        rowKey="lot_id"
      />
    </>
  );
};

export default TableProduct;